module.exports = __webpack_public_path__ + "static/img/bankong.b1e75532.png";